import {PlanItem, PlanItemRepeating} from "./types";
import {DateTime} from "mu-js-utils/lib/DateTime";

export class PlanItemRepeatingUtil {
    static dayNames: string[] = ['po', 'ut', 'st', 'čt', 'pá', 'so', 'ne'];
    static textual(itemRepeating: PlanItemRepeating): string
    {
        const res = [];
        if (itemRepeating.weekMod) res.push(`${itemRepeating.weekMod}. týden`);
        if (itemRepeating.dayOfWeek) res.push(this.formatDays(itemRepeating.dayOfWeek));
        res.push(this.formatSecondsAM(itemRepeating.secondsAM));

        return res.join(' ');
    }

    static formatDays(days: number[]) {
        days.sort((a, b) => a - b); // Seřadíme dny vzestupně

        const res = [];
        let rangeStart = null;

        for (let i = 0; i < days.length; i++) {
            if (rangeStart === null) {
                rangeStart = days[i];
            }

            if (i === days.length - 1 || days[i + 1] !== days[i] + 1) {
                if (rangeStart === days[i]) {
                    res.push(this.dayNames[rangeStart]);
                } else {
                    res.push(`${this.dayNames[rangeStart]} - ${this.dayNames[days[i]]}`);
                }
                rangeStart = null;
            }
        }

        return res.join(", ");
    }

    public static formatSecondsAM(value: number) {
        value = Math.floor(value / 60);
        return String(Math.floor(value / 60)).padStart(2, '0')
            + ':' + String(value % 60).padStart(2, '0');
    }

    public static inDay(items: PlanItem[], day: Date) {
        return items.filter(item => this.isMatch(day, item.repeating));
    }

    public static isMatch(day: Date, repeating: PlanItemRepeating): boolean
    {
        if (repeating.weekMod)
        {
            if (DateTime.getWeekNumberISO(day) % 2 !== parseInt(repeating.weekMod)) return false;
        }
        const wdn = (day.getDay() + 6) % 7;
        return repeating.dayOfWeek.map(s => parseInt(s)).includes(wdn);
    }

    static groupedForCalendar(data: PlanItem[], timeGranularity: number): Record<string,PlanItem[]> {
        const res: Record<string,PlanItem[]> = {};
        for (const item of data) {
            for (const week of (item.repeating.weekMod === '')
                ? [ 1, 2]
                : [ parseInt(item.repeating.weekMod) ]) {
                for (const dayNum of item.repeating.dayOfWeek) {
                    const k = this.calendarBlockKey(
                        week,
                        dayNum,
                        Math.floor(item.repeating.secondsAM / timeGranularity) * timeGranularity
                    );
                    if (!(res[k] ?? false)) res[k] = [];
                    res[k].push(item);
                }
            }
        }
        for (const k in res) {
            res[k].sort((a, b) => a.repeating.secondsAM - b.repeating.secondsAM);
        }

        return res;
    }

    static calendarBlockKey(week: number, dayNum: number, time: number): string
    {
        return `${week}-${dayNum}-${time}`;
    }
}
